import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { Users, Building2, CalendarCheck, TrendingUp, FileClock, ArrowRight } from "lucide-react";
import { get } from "@/lib/api";

function Stat({ icon: Icon, label, value, accent }) {
  return (
    <div className="rounded border border-[#CBD5E1] bg-white p-4">
      <div className="flex items-center gap-3">
        <div className={`flex h-9 w-9 items-center justify-center rounded ${accent}`}><Icon className="h-5 w-5" /></div>
        <div>
          <p className="text-2xl font-bold leading-none">{value}</p>
          <p className="mt-1 text-xs text-[#475569]">{label}</p>
        </div>
      </div>
    </div>
  );
}

export default function Dashboard() {
  const { data } = useQuery({ queryKey: ["admin-dashboard"], queryFn: () => get("/admin/dashboard") });
  if (!data) return <p className="text-[#475569]">Yükleniyor…</p>;

  return (
    <div>
      <h1 className="text-2xl font-semibold tracking-tight">Dashboard</h1>
      <p className="text-sm text-[#475569]">Platform genel bakış</p>

      <div className="mt-5 grid grid-cols-2 gap-3 lg:grid-cols-5">
        <Stat icon={Users} label="Toplam kullanıcı" value={data.total_users} accent="bg-blue-100 text-blue-700" />
        <Stat icon={Building2} label="Aktif stüdyo" value={data.active_studios} accent="bg-emerald-100 text-emerald-700" />
        <Stat icon={CalendarCheck} label="Bugünkü rezervasyon" value={data.today_bookings} accent="bg-violet-100 text-violet-700" />
        <Stat icon={TrendingUp} label="Toplam işlem hacmi" value={`${data.total_volume} kr`} accent="bg-amber-100 text-amber-700" />
        <Stat icon={FileClock} label="Bekleyen başvuru" value={data.pending_applications} accent="bg-rose-100 text-rose-700" />
      </div>

      <div className="mt-6 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {[
          { to: "/admin/kullanicilar", label: "Kullanıcıları görüntüle", icon: Users },
          { to: "/admin/studyolar", label: "Stüdyoları yönet", icon: Building2 },
          { to: "/admin/basvurular", label: "Başvuruları incele", icon: FileClock },
        ].map((c) => (
          <Link key={c.to} to={c.to} className="flex items-center justify-between rounded border border-[#CBD5E1] bg-white p-4 transition-colors hover:border-[#0F172A]">
            <span className="flex items-center gap-2 text-sm font-medium"><c.icon className="h-4 w-4 text-[#475569]" /> {c.label}</span>
            <ArrowRight className="h-4 w-4 text-[#94A3B8]" />
          </Link>
        ))}
      </div>
    </div>
  );
}
